import React from "react";
import style from "./index.module.scss";

const Index = ({ title }: { title: string }) => {
    return (
        <div className={style.root}>
            <span>*</span>
            {title}
        </div>
    );
};

export default Index;
